var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapper",class:`${_vm.rootClass}`},[_c('SmartText',{ref:"titleEl",class:`${_vm.rootClass}__title`,attrs:{"type":'hero-homepage-H1-thin',"noMargin":"","splitChars":""}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }